import React from 'react';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL } from '../utils/constants';
export function FinalCta() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-navy px-3 py-6 sm:px-5" data-id="element-74" data-mp="vhiv81mffeaf">
      <div className="mx-auto max-w-2xl text-center" data-id="element-75" data-mp="19cmaqagzlncz">
        <h2 id="final-cta-title" className="font-head text-2xl uppercase leading-[0.98] text-white sm:text-4xl" data-id="element-76" data-mp="15capowkppl0z">
          Stop searching. Start teaching.
        </h2>

        <div className="mt-2.5 rounded-2xl bg-white p-3 sm:p-4" data-id="element-77" data-mp="1eebkznwdxx00">
          <p className="font-head text-xl uppercase leading-none text-navy sm:text-3xl" data-id="element-78" data-mp="1ebxt1nx050wo">
            Kids Learning Ready™
          </p>
          <p className="mt-0.5 text-[10px] font-bold uppercase tracking-widest text-blue sm:text-xs" data-id="element-79" data-mp="1o3bonklu1gkj">
            The Complete Visual Learning System For Kids
          </p>
          <p className="mt-1 font-head text-sm uppercase text-green sm:text-lg" data-id="element-80" data-mp="2219zwh4uwwvt">
            See it. Understand it. Remember it.
          </p>

          <p className="mt-1.5 text-[12px] text-muted" data-id="element-81" data-mp="n6nu779cel10">
            Regular Price: <span className="line-through" data-id="element-82" data-mp="s4fkjwuc9z33">$97 USD</span>
          </p>
          <p className="font-head text-3xl leading-none text-green sm:text-5xl" data-id="element-83" data-mp="s6s1q7s9w5f3">TODAY: $27 USD</p>
          <span className="mt-1 inline-block rounded-full bg-coral px-2.5 py-0.5 font-head text-[11px] uppercase tracking-wide text-white" data-id="element-84" data-mp="x5v6dr4cc9mj">
            Save $70
          </span>

          <div className="mt-2.5 flex flex-col items-center" data-id="element-85" data-mp="163xeeqmhs2jb">
            <CtaButton href={CHECKOUT_URL} data-id="element-86" data-mp="1b31k37a7ji4w" />
            <TrustRow className="mt-1.5" accessLabel="Instant Digital Access" data-id="element-87" data-mp="1b1qkljnsowjl" />
          </div>
        </div>
      </div>
    </section>;
}